<template>
  <div class="flex items-center mb-1">
    <FormCheckbox
      @change="$store.dispatch('search/toggleFacet', { key: facetKey, value: onValue })"
      :value="search.facetRefinementList[facetKey]"
      :trueValue="onValue"
      :name="facetKey"
      :label="label"
      class="mb-0 clamp-1"
    />

    <span class="text-sm text-gray">{{ compFacetCount.toLocaleString() }}</span>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import FormCheckbox from '@/components/forms/elements/FormCheckbox'

export default {
  name: 'UtilSearchFacetSingleToggle',
  components: {
    FormCheckbox
  },
  props: {
    facetKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    onValue: [String, Boolean]
  },
  computed: {
    ...mapState({
      search: state => state.search
    }),

    compFacetCount() {
      // Dots in the key (meta.x) present a problem, wrap in double quotes
      if (!this.search.result || !get(this.search, `result._rawResults[0].facets["${this.facetKey}"]`)) {
        return 0
      }

      return get(this.search, `result._rawResults[0].facets["${this.facetKey}"][${this.onValue}]`) || 0
    }
  }
}
</script>
